export interface ILocalizacao {
  latitude: number | null;
  longitude: number | null;
}

export function pegarLocalizacao(): Promise<ILocalizacao> {
  if (typeof navigator === 'undefined' || !('geolocation' in navigator)) {
    return Promise.resolve({ latitude: null, longitude: null });
  }

  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(
      posicao => {
        resolve({
          latitude: posicao.coords.latitude,
          longitude: posicao.coords.longitude,
        });
      },
      () => {
        resolve({ latitude: null, longitude: null });
      },
      { timeout: 5000, maximumAge: 300000, enableHighAccuracy: false },
    );
  });
}

export default pegarLocalizacao;
